import { cn } from '@/lib/utils';
import { ClientAcceptanceVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ClientAcceptancePreviewCard from '@/features/dashboard/bookingChanges/components/flow/ClientAcceptancePreviewCard.tsx';
import ClientAcceptanceOperatorPanel from '@/features/dashboard/bookingChanges/components/flow/ClientAcceptanceOperatorPanel.tsx';
import ClientAcceptanceOutcomePanel from '@/features/dashboard/bookingChanges/components/flow/ClientAcceptanceOutcomePanel.tsx';
import ResendChangePanel from '@/features/dashboard/bookingChanges/components/flow/ResendChangePanel.tsx';

interface ChangePackageAcceptanceStepProps
  extends React.HTMLAttributes<HTMLDivElement> {
  view: ClientAcceptanceVm;
  resendChangeId: string | null;
}

/**
 * Krok W3 — podgląd tego, co po wysłaniu paczki zobaczy osoba zapisująca.
 *
 * Lewa karta jest kopią strony spod linku z maila, prawa kolumna tłumaczy
 * operatorowi, co ta wysyłka robi po jego stronie i co się stanie po decyzji
 * klienta.
 */
const ChangePackageAcceptanceStep = ({
  view,
  resendChangeId,
  className,
  ...props
}: ChangePackageAcceptanceStepProps) => (
  <div
    className={cn(
      'flex flex-col items-stretch gap-[22px] min-[1200px]:flex-row min-[1200px]:items-start',
      className,
    )}
    {...props}
  >
    <ClientAcceptancePreviewCard view={view} />

    <div className="flex min-w-0 flex-1 flex-col gap-4">
      <ClientAcceptanceOperatorPanel view={view} />
      {resendChangeId && <ResendChangePanel changeId={resendChangeId} />}
      <ClientAcceptanceOutcomePanel />
    </div>
  </div>
);

export default ChangePackageAcceptanceStep;
